import React from 'react';
import Overlay from 'Components/Overlay';
import Select from 'react-select';
const ConfirmationBranchListPopup = (props) => (
    <Overlay>
        <div className="bg-white box-shadow ph-20 pv-20 br-5">
            <div className="mb-10 tCenter header-medium-color fSemibold fs-18">
                {props.text}
            </div>
            <Select
                     isMulti
                    options={props.branchList}
                    className={'wt-300'}
                    placeholder="Select Branch"
                    value={props.selected}
                    onChange={props.handleBranchSelection}
                                    />
          <div>
          
          </div>
           <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" onClick={props.Confirm}>Save</button>
            </div>
          
        </div>    
    </Overlay> 

);

export default ConfirmationBranchListPopup;